import React, { useRef, useEffect, useState } from 'react';
import riskReducer from '../../../store/reducers/riskReducer';
import { connect } from "react-redux";
import { compose } from "redux";
import { useTranslation } from "react-i18next";
import {
  LineChart, Line, ResponsiveContainer, LabelList
} from 'recharts';

const RiskMetric = ({ height, data }) => {
  const { t } = useTranslation();
  // const data = [
  //   { name: 'Q1', value: 12 },
  //   { name: 'Q2', value: 15 },
  //   { name: 'Q3', value: 18 },
  //   { name: 'Q4', value: 14 },
  // ];

  const [processedData, setprocessedData] = useState([]);
  const [latestValue, setlatestValue] = useState(0);
  
  useEffect(() => {
      if (data?.length) {
        setprocessedData(data)
        setlatestValue(data[data?.length - 1].value)
      }
    }, [data]);


  return (
    <div 
      className="w-full bg-white rounded-lg flex flex-col justify-center" 
      style={{ 
        height: typeof height === 'string' ? height : `${height}px`,
        minHeight: '100px',
        maxHeight: '150px',
        padding: 'min(12px, 2vh) min(8px, 2vw)'
      }}
    >
      <div 
        className="text-gray-800 font-normal mb-1" 
        style={{ 
          fontSize: 'min(16px, 3.5vw)',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}
      >
        {latestValue} {t("generalDashboard.risks")}
      </div>

      <div className="flex-1 flex items-center justify-center" style={{ minHeight: '60px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={processedData}>
            <Line
              type="monotone"
              dataKey="value"
              stroke="#05769D"
              strokeWidth={2}
              dot={{ r: 2 }}
              isAnimationActive={false}
            >
              <LabelList 
                dataKey="value" 
                position="bottom" 
                offset={8} 
                style={{ fontSize: 'min(10px, 2.5vw)' }}
              />
            </Line>
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  //////console.log("Risk MEtrix data", state.dashboard)
    return {

      //token: state.auth.token,
      //departments: state.department.departments,
      //department_id: state.department.department_id
      data: state.dashboard.general_dashboard_data.quarter_risks

    };
};

const mapDispatchToProps = (dispatch) => {
    return {

    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(RiskMetric);